import { useState } from "react";
import { toast } from "sonner";
import { errMsg, useApi } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import { EMAIL_RX, crmErr } from "./helpers";
import LeadSourceSelect, { useLeadSources } from "./LeadSourceSelect";

export default function ContactDialog({ tid, onClose, onSaved }) {
  const api = useApi();
  const [f, setF] = useState({ name: "", email: "", phone: "", company: "", vat: "", tags: "", notes: "", marketing_consent: false, lead_source: "manual" });
  const opts = useLeadSources(tid);
  const badEmail = f.email.trim() && !EMAIL_RX.test(f.email.trim());
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setF((x) => ({ ...x, [k]: v }));
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/t/${tid}/crm/contacts`, { ...f, lead_source: f.lead_source || "", tags: f.tags.split(",").map((x) => x.trim()).filter(Boolean) });
      toast.success("Contatto creato"); onSaved(data);
    } catch (e) { toast.error(crmErr(e, errMsg)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-lg" data-testid="contact-dialog">
        <DialogHeader><DialogTitle>Nuovo contatto</DialogTitle></DialogHeader>
        <div className="grid gap-3 sm:grid-cols-2">
          <div className="sm:col-span-2"><Label className="text-xs">Nome *</Label><Input value={f.name} onChange={(e) => set("name", e.target.value)} data-testid="contact-name" /></div>
          <div><Label className="text-xs">Email</Label><Input type="email" value={f.email} onChange={(e) => set("email", e.target.value)} data-testid="contact-email" />
            {badEmail && <p className="mt-1 text-[11px] text-red-600" data-testid="contact-email-error">Email non valida</p>}</div>
          <div><Label className="text-xs">Telefono</Label><Input value={f.phone} onChange={(e) => set("phone", e.target.value)} data-testid="contact-phone" /></div>
          <div><Label className="text-xs">Azienda</Label><Input value={f.company} onChange={(e) => set("company", e.target.value)} data-testid="contact-company" /></div>
          <div><Label className="text-xs">Partita IVA</Label><Input value={f.vat} onChange={(e) => set("vat", e.target.value)} data-testid="contact-vat" /></div>
          <div><Label className="text-xs">Etichette (separate da virgola)</Label><Input value={f.tags} onChange={(e) => set("tags", e.target.value)} data-testid="contact-tags" /></div>
          <div><Label className="text-xs">Fonte del contatto</Label><LeadSourceSelect opts={opts} value={f.lead_source} onChange={(v) => set("lead_source", v)} testid="contact-lead-source" /></div>
          <div className="sm:col-span-2"><Label className="text-xs">Note</Label><Textarea rows={2} value={f.notes} onChange={(e) => set("notes", e.target.value)} data-testid="contact-notes" /></div>
          <label className="flex items-center gap-2 text-sm sm:col-span-2"><Switch checked={f.marketing_consent} onCheckedChange={(v) => set("marketing_consent", v)} data-testid="contact-consent" />
            Ha dato il consenso al marketing (registrato con data e autore)</label>
        </div>
        <DialogFooter><Button variant="outline" onClick={onClose}>Annulla</Button>
          <Button onClick={save} disabled={busy || !f.name.trim() || !!badEmail} data-testid="contact-save">{busy ? "Salvataggio…" : "Salva"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
